export const meta: BlockMeta = {
  title: "Project Header",
  tags: ["#page"],
  postMetaBlock: {
    fieldName: "projectHeader",
    postTypes: ["project"],
  },
}

import { Button } from "@components/atoms/Button"
import { ResponsiveImage } from "@components/atoms/ResponsiveImage"
import { Appear } from "@components/motion/Appear"
import { defineBlock, EditableText, InnerBlocks, usePostTitleEditor } from "eddev/blocks"
import { cn } from "tailwind-variants"

export default defineBlock("content/project-header", (props) => {
  return (
    <Appear className="relative block-spacing !mt-0">
      <div
        className={cn(
          "content-sized pb-8 flex flex-col items-start justify-end text-white",
          env.admin && "h-[60vh]",
          !env.admin && "h-[88vh] md:h-[100vh]",
        )}
      >
        <div className="absolute top-0 left-0 w-full h-full">
          {props.featuredImage?.mediaItemUrl && !props.featuredVideo?.mediaItemUrl && (
            <ResponsiveImage {...props.featuredImage} className="w-full h-full" objectFit="cover" />
          )}
          {props.featuredVideo?.mediaItemUrl && (
            <video className="w-full h-full object-cover" autoPlay loop muted>
              <source src={props.featuredVideo.mediaItemUrl} type="video/mp4" />
            </video>
          )}
        </div>
        <div className="absolute left-0 top-0 w-full h-[35vw] md:h-[20vw] bg-gradient-to-b from-[rgba(0,0,0,0.75)]" />
        <div className="absolute left-0 bottom-0 w-full h-[35vw] md:h-[20vw] bg-gradient-to-t from-[rgba(0,0,0,0.75)]" />
        <div className="flex flex-col w-full relative">
          <h2 className="type-mobile-headings-heading-xl md:type-desktop-headings-heading-xl">
            {env.admin ? (
              <EditableText as="span" store={usePostTitleEditor()} className="" placeholder="Enter a title" />
            ) : (
              props.project?.title
            )}
          </h2>
          <p className="type-mobile-headings-heading-xl md:type-desktop-headings-heading-xl text-concrete">
            {props.project?.projectHeader?.location?.[0]?.name}
          </p>
        </div>
      </div>
    </Appear>
  )
})
